// Indian number formatting helpers (Lakhs / Crores)

export function formatINR(amount, { compact = false, decimals = 0 } = {}) {
  if (amount === null || amount === undefined || Number.isNaN(amount)) return "—";
  const n = Number(amount);
  if (compact) {
    const abs = Math.abs(n);
    if (abs >= 1e7) return `₹${(n / 1e7).toFixed(2)} Cr`;
    if (abs >= 1e5) return `₹${(n / 1e5).toFixed(2)} L`;
    if (abs >= 1e3) return `₹${(n / 1e3).toFixed(1)}K`;
    return `₹${Math.round(n)}`;
  }
  return (
    "₹" +
    new Intl.NumberFormat("en-IN", {
      maximumFractionDigits: decimals,
      minimumFractionDigits: decimals,
    }).format(Math.round(n))
  );
}

export function formatCompactINR(amount) {
  return formatINR(amount, { compact: true });
}

export function formatPct(x, decimals = 0) {
  if (x === null || x === undefined || Number.isNaN(x)) return "—";
  return `${(x * 100).toFixed(decimals)}%`;
}
